<template>
    <div class="servicio">


        <v-container>
            <v-row>
                <v-col cols="3">
                    <h1>Fibra oscura</h1>
                </v-col>
            </v-row>
        </v-container>

    </div>    
</template>

<script>
export default {
    
}
</script>